var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete-row"},[_c('div',{staticClass:"delete-btn",on:{"click":function($event){return _vm.$emit('deleteClick')}}},[_c('img',{staticClass:"remove-icon",attrs:{"src":require("../../assets/remove.png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }